import { MuiDialogActions, MuiDialogContent, MuiDialogTitle, MuiDialog } from './MuiDialog';
import { MuiBreadcrumbs } from './MuiBreadcrumbs';
import { MuiButton } from './MuiButton';
import { MuiDrawer } from './MuiDrawer';
import { MuiTooltip } from './MuiTooltip';
import { MuiTab, MuiTabs } from './MuiTabs';
import { MuiTable, MuiTableCell, MuiTableRow } from './MuiTable';
import { MuiDateCalendar } from './MuiDateCalendar';
import { MuiAccordion, MuiAccordionSummary, MuiAccordionDetails } from './MuiAccordion';

const MuiAlert = {
  defaultProps: {
    variant: 'outlined',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

const MuiFormField = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

const MuiTextField = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

const MuiSelect = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

export const components = {
  MuiTooltip: MuiTooltip,
  MuiButton: MuiButton,
  MuiAccordion: MuiAccordion,
  MuiAccordionSummary: MuiAccordionSummary,
  MuiAccordionDetails: MuiAccordionDetails,
  MuiTabs: MuiTabs,
  MuiTab: MuiTab,
  MuiDrawer: MuiDrawer,
  MuiTable: MuiTable,
  MuiTableRow: MuiTableRow,
  MuiTableCell: MuiTableCell,
  MuiAlert: MuiAlert,
  MuiFormField: MuiFormField,
  MuiTextField: MuiTextField,
  MuiSelect: MuiSelect,
  MuiDateCalendar: MuiDateCalendar,
  MuiBreadcrumbs: MuiBreadcrumbs,
  MuiDialogContent: MuiDialogContent,
  MuiDialogActions: MuiDialogActions,
  MuiDialogTitle: MuiDialogTitle,
  MuiDialog: MuiDialog,
};